import type { SubmenuType } from '../types'

export const getPrevSubmenu = (activeSubmenu: SubmenuType) => {
  switch (activeSubmenu) {
    case 'smAFRShortTerm':
    case 'smAFRLuxury':
    case 'smAFRPetFriendly':
    case 'smAFRCheap':
      return 'smAmenities'
    default:
      return 'smMain'
  }
}
